// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldPhone_labelContainer__y0Gq9"};